import React from 'react';
import './PetskedTitle.scss';
export type HeadingProps = {
  size?: 'sm' | 'lg';
  alignText?: 'left' | 'center';
  title?: string;
  highlightTitle?: string;
  description?: string;
  noPadding?:string
  removeBgcolor?: string;
};

export const PetskedTitle = ({ size, title, description, highlightTitle, alignText, noPadding, removeBgcolor }: HeadingProps) => {
  return (
    <div className={`heading-section ${alignText} ${noPadding} ${removeBgcolor}`}>
      {size == 'sm' ? (
        <h6>
          {title} <span>{highlightTitle}</span>
        </h6>
      ) : (
        <h5>
          {title} <span>{highlightTitle}</span>
        </h5>
      )}
      <p>{description}</p>
    </div>
  );
};

PetskedTitle.displayName = 'Heading';
